// =============================================================
// custom.js - Version unifiée
// =============================================================

// 1) VARIABLES & OUTILS
// -------------------------------------------------------------

var selectedPrices = []; // Pour gérer la somme (bundle)

// a) Trouver le bouton "Add to cart"
function findAddToCartButton() {
  // Priorité au bundle (.ctm_addtocart)
  let btn = document.querySelector('.ctm_addtocart');
  // Sinon, produit simple => .product-form__submit.button--primary
  if (!btn) {
    btn = document.querySelector('.product-form__submit.button--primary');
  }
  return btn;
}

// b) Trouver l'élément prix du thème (pour produit simple)
function findThemePriceElement() {
  let el = document.querySelector('.price__sale.whitespace-nowrap');
  if (!el) el = document.querySelector('.price__regular.whitespace-nowrap');
  if (!el) el = document.querySelector('.price__unavailable.whitespace-nowrap');
  return el;
}

// c) Récupérer le prix affiché (bundle ou simple)
function getDisplayedPrice() {
  // 1) Cas "bundle" => .price-mm
  let bundlePriceEl = document.querySelector('.price-mm');
  if (bundlePriceEl) {
    let text = bundlePriceEl.innerText.trim();
    if (text) {
      return text; // ex: "99,00 €"
    }
  }
  // 2) Sinon, produit simple => chercher la classe du thème
  let themePriceEl = findThemePriceElement();
  if (themePriceEl) {
    return themePriceEl.innerText.trim();
  }
  return ''; // Pas de prix trouvé
}

// 2) LOGIQUE BUNDLE : CALCUL DU PRIX TOTAL
// -------------------------------------------------------------
function updateTotalPrice() {
  // On additionne le prix de chaque bloc .variant-picker_mt
  selectedPrices = [];
  $('.variant-picker_mt').each(function () {
    let price = parseFloat($(this).attr('var_price')) || 0;
    selectedPrices.push(price);
  });
  let total = selectedPrices.reduce((acc, val) => acc + val, 0);

  // On l'affiche dans .price-mm (s'il existe)
  let $priceMm = $(".price-mm");
  if ($priceMm.length) {
    $priceMm.html(theme.Currency.formatMoney(total, theme.settings.moneyFormat));
  }
}

// 3) LOGIQUE BUNDLE : VARIANTES ÉPUISÉES
// -------------------------------------------------------------
function updateSoldOutVariants($section, selectedColor) {
  // On lit la liste des <option disabled> dans .find-variant-info select
  // => elles ont data-variant="Couleur / Taille"
  let soldOutVariants = $('.find-variant-info select option:disabled')
    .map(function () {
      return $(this).attr('data-variant');
    })
    .get();

  // On cible les champs "taille" du bloc
  let $sizeOptions = $section.find('.product-form__input_mt[data-option-slug="taille"] input');

  // On active/désactive selon la rupture
  $sizeOptions.each(function () {
    let sizeValue = $(this).val();
    let variantKey = `${selectedColor} / ${sizeValue}`;
    if (soldOutVariants.includes(variantKey)) {
      $(this).prop('disabled', true).addClass('disabled');
    } else {
      $(this).prop('disabled', false).removeClass('disabled');
    }
  });

  // Si la taille actuellement cochée est épuisée, on bascule sur la première disponible
  let firstAvailableSize = $sizeOptions.not('.disabled').first();
  let currentSize = $sizeOptions.filter(':checked').val();
  if (firstAvailableSize.length && soldOutVariants.includes(`${selectedColor} / ${currentSize}`)) {
    firstAvailableSize.trigger('click');
  }
}

// 4) GESTION DU SWATCH (COULEUR/TAILLE) : BUNDLE ET THÈME
// -------------------------------------------------------------
$(document).on('change', '.swatch_mt', function () {
  let $section = $(this).closest('.product-section');

  // Récupère la couleur et la taille
  let selectedColor = $section.find('[data-option-slug="couleur"] input:checked').val();
  let selectedSize  = $section.find('[data-option-slug="taille"]  input:checked').val();
  if (!selectedColor || !selectedSize) return;

  // "Bleu / M" par ex.
  let formattedText = `${selectedColor} / ${selectedSize}`;

  // Dans .select_ option, on cherche data-variant="Bleu / M"
  let $matchingOption = $('.select_ option').filter(function () {
    return $(this).data('variant') === formattedText;
  });

  if ($matchingOption.length) {
    let variantValue = $matchingOption.val();              // ex: "123456789"
    let variantPrice = parseFloat($matchingOption.attr('data-price')) || 0;

    // Mettre à jour .variant-picker_mt => pour la somme du bundle
    $section.find('.variant-picker_mt')
      .attr('selected_var', variantValue)
      .attr('var_price', variantPrice);

    // MAJ du select[name="id"] du thème => changement d'images, etc.
    let $themeSelect = $section.find('form.product-form select[name="id"]');
    if ($themeSelect.length) {
      $themeSelect.val(variantValue).trigger('change');
    }

    // 1) Recalcule le total (bundle)
    updateTotalPrice();
    // 2) Désactive les variantes hors stock
    updateSoldOutVariants($section, selectedColor);

  } else {
    console.log("No matching option found for:", formattedText);
  }
});

// 5) BOUTON "AJOUTER AU PANIER" (MULTI-ARTICLES POUR LE BUNDLE)
// -------------------------------------------------------------
$(document).on('click', '.ctm_addtocart', function () {
  // On construit un tableau { id: variantId, quantity: 1 } pour chaque .variant-picker_mt
  let selectedVariants = $('.variant-picker_mt').map(function () {
    let variantId = $(this).attr('selected_var');
    return variantId ? { id: variantId, quantity: 1 } : null;
  }).get();

  if (selectedVariants.length === 0) {
    alert("Veuillez sélectionner une variante pour chaque produit.");
    return;
  }

  let btn = $(this);
  btn.addClass("is-loading");

  // On envoie un /cart/add.js groupé
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { items: selectedVariants },
    dataType: "json",
    success: function (response) {
      console.log("Added to cart:", response);

      // On rafraîchit le mini-panier
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          $("cart-count").html(cart.item_count).removeAttr("hidden");

          let cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.show();
          }
        });
    },
    error: function (error) {
      console.log("Error adding to cart:", error);
      alert("Impossible d'ajouter au panier. Veuillez réessayer.");
    },
    complete: function () {
      btn.removeClass("is-loading");
    }
  });
});

// 6) FONCTION appendPriceIfNeeded : ÉVITER LES DOUBLONS
// -------------------------------------------------------------
function appendPriceIfNeeded(buttonEl) {
  if (!buttonEl) return;

  // Bouton désactivé => ne rien faire
  if (buttonEl.hasAttribute('disabled') || buttonEl.hasAttribute('unavailable')) {
    return;
  }

  // On cherche .btn-text span
  let btnTextSpan = buttonEl.querySelector('.btn-text span');
  if (!btnTextSpan) {
    btnTextSpan = buttonEl.querySelector('.btn-text') || buttonEl;
  }

  let currentText = btnTextSpan.textContent.trim();
  let lowerText   = currentText.toLowerCase();

  // Cas "Ajouter au panier" ou "Add to cart"
  if (lowerText.includes('add to cart') || lowerText.includes('ajouter au panier')) {
    // On récupère le prix (bundle ou simple)
    let displayedPrice = getDisplayedPrice();
    if (!displayedPrice) return;

    // On normalise pour éviter "45,00€" vs "45,00 €"
    let normalizedText      = currentText.replace(/\s/g, '');
    let normalizedDisplayed = displayedPrice.replace(/\s/g, '');

    // Déjà un "-" (signe qu'on a ajouté le prix) ?
    // ou le prix lui-même ?
    if (normalizedText.includes('-') || normalizedText.includes(normalizedDisplayed)) {
      return;
    }

    // On ajoute " - XX,XX €"
    btnTextSpan.textContent = currentText + " - " + displayedPrice;
  }
}

// 7) OBSERVER LE BOUTON POUR Y RAJOUTER LE PRIX
// -------------------------------------------------------------
function setupButtonObserver() {
  let addToCartButton = findAddToCartButton();
  if (!addToCartButton) {
    console.log("Aucun bouton trouvé (ni .ctm_addtocart ni .product-form__submit)");
    return;
  }

  // On utilise un MutationObserver qui surveille le bouton (childList, attributes)
  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        appendPriceIfNeeded(addToCartButton);
      }
    }
  });

  observer.observe(addToCartButton, {
    childList: true,
    subtree: true,
    attributes: true
  });

  // On fait un premier passage
  appendPriceIfNeeded(addToCartButton);
}

// 8) DOMContentLoaded => INITIALISATION GLOBALE
// -------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  // a) Calcul initial du total (pour le bundle s'il existe)
  updateTotalPrice();

  // b) Installer l'observateur sur le bouton
  setupButtonObserver();

  // c) Surveiller le prix .price-mm (bundle)
  let priceMmEl = document.querySelector('.price-mm');
  if (priceMmEl) {
    new MutationObserver(() => {
      // Si la somme du bundle change => on ré-insère dans le bouton
      let btn = findAddToCartButton();
      appendPriceIfNeeded(btn);
    }).observe(priceMmEl, { childList: true, subtree: true });
  }

  // d) Surveiller le prix du thème (produit simple)
  let themePriceEl = findThemePriceElement();
  if (themePriceEl) {
    new MutationObserver(() => {
      // Si le thème change son prix => on ré-insère
      let btn = findAddToCartButton();
      appendPriceIfNeeded(btn);
    }).observe(themePriceEl, { childList: true, subtree: true });
  }
});
